import {
  GET_USER_MANAGEMENT,
  GET_USER_MANAGEMENT_SUCCESS,
  GET_USER_MANAGEMENT_FAILURE,
  SHOW_USER_MANAGEMENT,
  SHOW_USER_MANAGEMENT_SUCCESS,
  SHOW_USER_MANAGEMENT_FAILURE,
  UPDATE_USER_MANAGEMENT,
  UPDATE_USER_MANAGEMENT_SUCCESS,
  UPDATE_USER_MANAGEMENT_FAILURE,
} from "../types";

export const getUserManagement = (payload) => ({
  type: GET_USER_MANAGEMENT,
  payload
});
export const getUserManagementSuccess = (payload) => ({
  type: GET_USER_MANAGEMENT_SUCCESS,
  payload,
});
export const getUserManagementFailure = (payload) => ({
  type: GET_USER_MANAGEMENT_FAILURE,
  payload,
});

export const showUserManagement = (payload) => ({
  type: SHOW_USER_MANAGEMENT,
  payload
});
export const showUserManagementSuccess = (payload) => ({
  type: SHOW_USER_MANAGEMENT_SUCCESS,
  payload,
});
export const showUserManagementFailure = (payload) => ({
  type: SHOW_USER_MANAGEMENT_FAILURE,
  payload,
});

export const updateUserManagement = (payload) => ({
  type: UPDATE_USER_MANAGEMENT,
  payload
});
export const updateUserManagementSuccess = (payload) => ({
  type: UPDATE_USER_MANAGEMENT_SUCCESS,
  payload,
});
export const updateUserManagementFailure = (payload) => ({
  type: UPDATE_USER_MANAGEMENT_FAILURE,
  payload,
});
